import { useStoreState } from "atoms/storeAtom";
import { StoreItem } from "types";

import { Row } from "components/Row/Row";
import { Paragraph } from "components/Paragraph/Paragraph";

import styles from "../styles.module.scss";
import { useGetStores } from "../api";

export const StockList = (): JSX.Element => {
  const { storeState, setStoreState } = useStoreState();

  const { data: stocks = [] } = useGetStores(
    {},
    {
      onSuccess: (data) => {
        if (data?.length) {
          setStoreState({ activeItem: data[0] });
        }
      },
    }
  );

  const handleRowClick = (item: StoreItem) => {
    setStoreState({ activeItem: item });
  };

  return (
    <div className={styles.productsList}>
      {stocks.map((store: any) => (
        <Row
          key={store.storesid}
          isActive={storeState.activeItem?.storesid === store.storesid}
          onClick={() => handleRowClick(store)}
        >
          <Paragraph>{store.name}</Paragraph>
        </Row>
      ))}
    </div>
  );
};
